import { buildURLPath } from "@/utils/utils";

import {
  adminDashboardChunks,
  applicationsChunks,
  assetsChunks,
  batchPredictionChunks,
  connectorsChunks,
  dashboardChunks,
  datasetsChunks,
  executionChunk,
  machinesChunks,
  monitoringChunks,
  settingsChunks,
} from "./PathChunksNames";

const basePathNames = {
  datasetDetails: `/${datasetsChunks.datasets}/${datasetsChunks.details}`,
  monitoringQC: `/${monitoringChunks.monitoring}/${monitoringChunks.qc}`,
  monitoringQCBatchPrediction: buildURLPath([
    monitoringChunks.monitoring,
    monitoringChunks.qc,
    monitoringChunks.qcBatchPrediction,
  ]),
  monitoringQCRealtime: buildURLPath([monitoringChunks.monitoring, monitoringChunks.qc, monitoringChunks.qcRealTime]),
  monitoringQCRealtimeCameras: buildURLPath([
    monitoringChunks.monitoring,
    monitoringChunks.qc,
    monitoringChunks.qcRealTime,
    monitoringChunks.qcRealTimeCameras,
  ]),
  qcRealTimeCameraDetails: buildURLPath([
    monitoringChunks.monitoring,
    monitoringChunks.qc,
    monitoringChunks.qcRealTime,
    monitoringChunks.qcRealTimeCameras,
    monitoringChunks.qcRealTimeCameraMonitor,
  ]),
  batchPredictionMonitorDetails: buildURLPath([
    monitoringChunks.monitoring,
    monitoringChunks.qc,
    monitoringChunks.qcBatchPrediction,
    monitoringChunks.qcBatchPredictionMonitor,
  ]),
  monitoringQCRealtimeDatasources: buildURLPath([
    monitoringChunks.monitoring,
    monitoringChunks.qc,
    monitoringChunks.qcRealTime,
    monitoringChunks.qcRealTimeDataSources,
  ]),
  monitoringQCRealtimeDatasourcesStats: buildURLPath([
    monitoringChunks.monitoring,
    monitoringChunks.qc,
    monitoringChunks.qcRealTime,
    monitoringChunks.qcRealTimeDataSources,
    monitoringChunks.stats,
  ]),
  qcRealTimeDatasourceDetails: buildURLPath([
    monitoringChunks.monitoring,
    monitoringChunks.qc,
    monitoringChunks.qcRealTime,
    monitoringChunks.qcRealTimeDataSources,
    monitoringChunks.qcRealTimeDatasourceMonitor,
  ]),
};

export const AppPathNames = {
  root: "/",
  signIn: "/signin",
  signupInvitation: "/signup/:invitation_id",
  recover: "/user-recover",
  resetPassword: "/resetpassword/:token",
  activateEmail: "/activate/:email/:token",
  resendActivation: "/resend-activation",
  pageNotFound: "/404",
  onedriveSuccessRedirect: "/onedrive/success",
  dashboard: `/${dashboardChunks.dashboard}`,

  /****** Datasets path names  *****/

  datasets: `/${datasetsChunks.datasets}`,
  newDataset: `/${datasetsChunks.datasets}/${datasetsChunks.new}`,
  newDatasetType: `/${datasetsChunks.datasets}/${datasetsChunks.new}/${datasetsChunks.type}`,
  datasetPreview: `${basePathNames.datasetDetails}/${datasetsChunks.preview}`,
  datasetVisualize: `${basePathNames.datasetDetails}/${datasetsChunks.visualize}`,
  datasetTrain: `${basePathNames.datasetDetails}/${datasetsChunks.train}`,
  datasetPredict: `${basePathNames.datasetDetails}/${datasetsChunks.predict}`,
  datasetUSDeploy: `${basePathNames.datasetDetails}/${datasetsChunks.usDeploy}`,
  datasetQCDeploy: `${basePathNames.datasetDetails}/${datasetsChunks.qcDeploy}`,
  executionDetails: `/${executionChunk}`,

  /****** Assets path names  *****/

  browseFiles: `/${assetsChunks.assets}`,
  uploadFile: `/${assetsChunks.assets}/${assetsChunks.new}`,
  fileDetail: `/${assetsChunks.assets}/${assetsChunks.details}`,

  /****** Monitoring path names  *****/
  monitoring: `/${monitoringChunks.monitoring}`,
  monitoringQC: `${basePathNames.monitoringQC}`,

  monitoringQCBatchPrediction: `${basePathNames.monitoringQCBatchPrediction}`,

  monitoringQCRealtime: `${basePathNames.monitoringQCRealtime}`,
  monitoringQCRealtimeCameras: `${basePathNames.monitoringQCRealtimeCameras}`,

  monitoringQCRealtimeDatasources: `${basePathNames.monitoringQCRealtimeDatasources}`,
  monitoringQCRealtimeDatasourcesStats: `${basePathNames.monitoringQCRealtimeDatasourcesStats}`,
  qcRealTimeDatasourceDetails: `${basePathNames.qcRealTimeDatasourceDetails}`,
  qcRealTimeDatasourceDetailsAssignments: `${basePathNames.qcRealTimeDatasourceDetails}/assignments`,
  qcRealTimeDatasourceImageDetails: `${basePathNames.qcRealTimeDatasourceDetails}/${monitoringChunks.imageDetails}`,
  qcRealTimeDataSourceAnalytics: `${basePathNames.qcRealTimeDatasourceDetails}/${monitoringChunks.analytics}`,
  qcRealTimeDataSourceData: `${basePathNames.qcRealTimeDatasourceDetails}/${monitoringChunks.data}`,

  batchPredictionMonitorDetails: `${basePathNames.batchPredictionMonitorDetails}`,
  batchPredictionMonitorAnalytics: `${basePathNames.batchPredictionMonitorDetails}/${monitoringChunks.analytics}`,
  batchPredictionMonitorImageDetails: `${basePathNames.batchPredictionMonitorDetails}/${monitoringChunks.imageDetails}`,
  monitoringHoyaAlerts: `${basePathNames.batchPredictionMonitorDetails}/${monitoringChunks.alerts}`,
  monitoringHoyaAlertsCreate: `${basePathNames.batchPredictionMonitorDetails}/${monitoringChunks.alerts}/${monitoringChunks.alertsCreate}`,
  monitoringHoyaAlertsEdit: `${basePathNames.batchPredictionMonitorDetails}/${monitoringChunks.alerts}/${monitoringChunks.alertsEdit}`,

  qcRealTimeCameraDetails: `${basePathNames.qcRealTimeCameraDetails}`,
  qcRealTimeCameraImageDetails: `${basePathNames.qcRealTimeCameraDetails}/${monitoringChunks.imageDetails}`,

  qcRealTimeCameraGroupDetails: `${basePathNames.monitoringQC}/${monitoringChunks.qcRealTime}/${monitoringChunks.qcRealTimeCameras}/${monitoringChunks.qcRealTimeCameraGroupMonitor}`,
  qcRealTimeCameraGroupImageDetails: `${basePathNames.monitoringQC}/${monitoringChunks.qcRealTime}/${monitoringChunks.qcRealTimeCameras}/${monitoringChunks.qcRealTimeCameraGroupMonitor}/${monitoringChunks.imageDetails}`,

  /****** Batch Prediction path names  *****/
  batchPredictions: `/${batchPredictionChunks.batchPrediction}`,
  batchPredictionCreate: `/${batchPredictionChunks.batchPrediction}/${batchPredictionChunks.create}`,
  batchPredictionResults: `/${batchPredictionChunks.batchPrediction}/${batchPredictionChunks.results}`,
  batchPredictionImageDetails: `/${batchPredictionChunks.batchPrediction}/${batchPredictionChunks.results}/${batchPredictionChunks.imageDetails}`,

  /****** Connectors path names  *****/
  connectors: `/${connectorsChunks.connectors}`,
  connectorsCreate: `/${connectorsChunks.connectors}/${connectorsChunks.create}`,

  /****** Applications path names  *****/

  manageApplications: `/${applicationsChunks.application}`,
  manageApplicationsCreate: `/${applicationsChunks.application}/${applicationsChunks.create}`,
  manageApplicationsInfo: `/${applicationsChunks.application}/${applicationsChunks.details}`,

  /****** Admin dashboard path names  *****/

  adminDashboard: `/${adminDashboardChunks.adminDashboard}`,
  manageUsers: `/${adminDashboardChunks.adminDashboard}/${adminDashboardChunks.users}`,
  manageUsersEditUser: `/${adminDashboardChunks.adminDashboard}/${adminDashboardChunks.users}/${adminDashboardChunks.userDetails}`,
  trackingStatistics: `/${adminDashboardChunks.adminDashboard}/${adminDashboardChunks.users}/${adminDashboardChunks.userDetails}/${adminDashboardChunks.userStatistics}`,
  manageOrganizations: `/${adminDashboardChunks.adminDashboard}/${adminDashboardChunks.orgs}`,
  manageOrganizationsCreate: `/${adminDashboardChunks.adminDashboard}/${adminDashboardChunks.orgs}/${adminDashboardChunks.orgCreate}`,
  organizationDetails: `/${adminDashboardChunks.adminDashboard}/${adminDashboardChunks.orgs}/${adminDashboardChunks.orgDetails}`,
  trackingOrgStatistics: `/${adminDashboardChunks.adminDashboard}/${adminDashboardChunks.orgs}/${adminDashboardChunks.orgDetails}/${adminDashboardChunks.orgStatistics}`,
  manageRoles: `/${adminDashboardChunks.adminDashboard}/${adminDashboardChunks.roles}`,
  resources: `/${adminDashboardChunks.adminDashboard}/${adminDashboardChunks.resources}`,
  alerts: `/${adminDashboardChunks.adminDashboard}/${adminDashboardChunks.alerts}`,
  alertsCreate: `/${adminDashboardChunks.adminDashboard}/${adminDashboardChunks.alerts}/${adminDashboardChunks.alertsCreate}`,
  alertsEdit: `/${adminDashboardChunks.adminDashboard}/${adminDashboardChunks.alerts}/${adminDashboardChunks.alertsEdit}`,

  /******* Settings path names  *****/

  settings: `/${settingsChunks.settings}`,
  manageTeam: `/${settingsChunks.settings}/${settingsChunks.team}`,
  manageInvitations: `/${settingsChunks.settings}/${settingsChunks.invitations}`,
  manageModelsList: `/${settingsChunks.settings}/${settingsChunks.modelsList}`,
  manageOrganizationStats: `/${settingsChunks.settings}/${settingsChunks.team}/${settingsChunks.orgStatistics}`,
  manageUserStats: `/${settingsChunks.settings}/${settingsChunks.team}/${settingsChunks.userStatistics}`,
  manageTeamEditUser: `/${settingsChunks.settings}/${settingsChunks.team}/${settingsChunks.userDetails}`,

  /******* Machines path names  *****/

  machines: `/${machinesChunks.machines}`,
  qcMachines: `/${machinesChunks.machines}/${machinesChunks.qc}`,
  qcMachinesCameraDetails: `/${machinesChunks.machines}/${machinesChunks.qc}/${machinesChunks.qcDetails}`,
  qcMachinesCameraEdit: `/${machinesChunks.machines}/${machinesChunks.qc}/${machinesChunks.qcEdit}`,
  qcMachinesCameraWizard: `/${machinesChunks.machines}/${machinesChunks.qc}/${machinesChunks.qcCameraWizard}`,
  qcMachinesCameraWizardDetails: `/${machinesChunks.machines}/${machinesChunks.qc}/${machinesChunks.qcEditCameraWizard}`,

  businessSignup: "/signup/uipath-user/:tag",
  datasetMonitor: "/datasets/deployment/:id/:execution_id",
  browseModels: "/models",
  uploadModel: "/models/new",
  modelsDetail: "/models/:id",
  tempRoute: "/test-bench",
};

//Forbidden paths for user
export const UserPathNames = {
  manageApplications: "/manage-applications",
};

//Forbidden paths for uipath user
export const UiPathUserPathNames = {
  datasetMonitor: "/datasets/deployment/:id/:execution_id",
  datasetQCDeploy: "/datasets/qc-deployment/:id/:execution_id",
  browseFiles: "/files",
  uploadFile: "/files/new",
  fileDetail: "/files/:id",
  monitoring: "/monitoring",
  monitoringQC: "/monitoring/qc",
  imageDetail: "/monitoring/qc/image-detail",
  addCamera: "/monitoring/qc/add-camera",
  manageApplications: "/manage-applications",
  // manageApplicationsEdit: "/manage-applications-edit/:appId",
};
